/* eslint-disable no-undef */
import React from "react";
import { Link } from "react-router-dom";
import drprocoSvg from '../../../../public/prodr.svg';
import penicoSvg from '../../../../public/pendingico.svg';
import ProductService from '../../../../services/ProductService';
import { showLoading } from 'react-global-loading';
class PractitionersProductsList extends React.Component {
  constructor(props) {
    super(props);
    showLoading(true);
    this.state = {
      userID: props.match.params.id,
      filteredList: [], approved: [], pending: [], products: []
    };
  }

  componentDidMount = () => {
    this.getAllProducts();
  };

  getAllProducts = () => {
    ProductService.fetchAllProduct({ 'user': this.state.userID })
      .then((result) => {
        if (!result) {
          return;
        }

        this.setState({ productsList: result });
        result.map((item, index) => {
          item.post_status === 'pending' ? this.setState({
            pending: [...this.state.pending, item]
          }) : this.setState({
            approved: [...this.state.approved, item]
          });
        });
        this.eventType(1);
        showLoading(false);

      })
      .catch((err) => {
        console.error(err);
      });
  };



  eventType = (type) => {
    this.setState({ docType: type });

    let filteredList = [];
    this.state.productsList.map((item, index) => {

      switch (type) {
        case 1://all
          filteredList = this.state.productsList;
          break;
        case 2://pending
          item.post_status === "pending" && filteredList.push(item);
          break;
        case 3://approved
          item.post_status === "publish" && filteredList.push(item);
          break;
      }
    });
    this.setState({ filteredList });
  };



  render() {
    const { productsList, filteredList, pending, approved } = this.state;

    return (
      <>
        <div className="container-fluid productscontainer" id="main">


          <hr></hr>
          <div className="row mt-3">
            <div className="col-md-6">
              <h3><b>Products</b></h3>
            </div>
            <div className="col-md-6 btr">
              {/* <button className="btn btndbg" onClick={() => this.pdfDownload()}>
                Export
              </button > */}
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-12">
              <ul className="nav nav-tabs admintabs" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button className="nav-link active" id="view-all-documents-tab" onClick={() => this.eventType(1)} data-bs-toggle="tab" type="button" role="tab" aria-selected="true">All <span className="badge text-bg-secondary rounded-circle">{productsList?.length}</span></button>
                </li>
                <li className="nav-item" role="presentation">
                  <button onClick={() => this.eventType(3)} className="nav-link  t1" id="all-pendingapprove-documents-tab" data-bs-toggle="tab" type="button" role="tab" aria-selected="false"> Approved <span className="badge text-bg-secondary rounded-circle">{approved.length}</span></button>
                </li>
                <li className="nav-item" role="presentation">
                  <button onClick={() => this.eventType(2)} className="nav-link t1" id="all-pendingapprove-documents-tab" data-bs-toggle="tab" type="button" role="tab" aria-selected="false">Pending <span className="badge text-bg-secondary rounded-circle">{pending.length}</span></button>
                </li>
              </ul>
              <div className="tab-content bg-white pt-4 px-4 mt-4" >
                <div className="tab-pane fade show active" id="all-practitioners-products-list-pane" role="tabpanel" aria-labelledby="all-practitioners-products-list-pane" >

                  <div className="row bg-light p-2 pt-4 mt-3 mb-3 rounded rounded-2">
                    <div className="col-12">
                      <div className="row view-group">
                        {filteredList.length > 0 ?
                          filteredList.map((item, index) =>

                            <div className="col-md-3 mb-3">
                              <div className="card p-3 event-card crdev_red">
                                <div className="imgrel">
                                  <Link to="/">  <img src={item.product_image[0]} className="img-fluid card-img-top rounded prod-img" alt="products" /></Link>
                                </div>
                                <div className="evtxcn px-0 ">
                                  <h4 className="evh">
                                    <span className="evhd p-tit t2">{item.post_title}
                                      <span className="card-subtitle mb-2 text-dark float-end fw-bold t1"><i className="fa fa-inr" aria-hidden="true" />{item.product_price}</span>
                                    </span>
                                  </h4>
                                  <span className="muted d-block mt-1 doccell t4">
                                    <img src={drprocoSvg} alt="name" /> Dr Vivek’s Naturopathy
                                  </span>
                                  <p className="evdes_nw t4">{item.post_content}</p>
                                </div>
                              </div>
                              <div className={item.post_status === "pending" ? "crbotm_red" : "crbotm"}>
                                <p className="dtpr fs-9">Added - <span className="cdte">24 / 03 / 2023</span></p>
                                <span className="dtpr fs-9">|</span>
                                <Link to='/' className="linknormal" data-bs-toggle="modal" data-bs-target="#productapproval"><p className="dtpr fs-9">Approval Pending <img src={penicoSvg} alt="name" />
                                </p></Link>
                              </div>
                            </div>
                          ) : <span>No Products found</span>}
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

      </>
    );
  }
}
export default PractitionersProductsList;